module.controller('subFeedCtrl', ['$scope', '$state', '$stateParams', '$http', '$filter', 'TransactionService', 'baseURI',
  function ($scope, $state, $stateParams, $http, $filter, TransactionService, baseURI){
    var url = baseURI + 'card/sub-cards';
    var subUrl = baseURI + 'transactions/all/0/15/?Username=';
    $scope.transactions = [];
    $scope.feedTitle = 'Your sub-cards';

    $scope.getSubs = function(callback){
      $scope.loading = true;
      $http.get(url, {cache: true}).then(function (resp){
        var subCards = resp.data.Data;
        $scope.feedTitle = 'Your sub-cards';
        $scope.subCards = subCards;
        $scope.loading = false;

        if(callback){
          callback();
        }

      }).catch(function (error){
        $scope.loading = false;
        console.log('err', error);
      });
    };

    $scope.getSubTransactions = function(username, balance, firstName){
      for(var s in $scope.subCards){
        if($scope.subCards[s].Username == username){
          balance = $scope.subCards[s].Balance;
        }
      }
      $scope.loading = true;
      $http.get(subUrl + username, {cache: false}).then(function (resp){
        var akimboFeed = transformFeed(resp.data.Data.Transactions, balance);
        TransactionService.update(akimboFeed.transactions);
        $scope.akimboFeed = akimboFeed;
        $scope.loading = false;
        $scope.feedTitle = 'All Cards';
        $scope.subTitle = firstName + '\'s Balance ' + $filter('akimboCurrency')(balance, '$');
      }).catch(function (error){
        $scope.loading = false;
        $scope.getSubs();
      });
    };

    var transformFeed = function(feed, balance){
      var akimboFeed = {};
      var notifications = [];
      var transactions = [];

      for(var f in feed){
        if(feed[f].IsNotification){
          feed[f].Id = f;
          notifications.push(feed[f]);
        } else {
          transactions.push(feed[f]);
        }
      }

      akimboFeed.notifications = formatNotifications(notifications);
      akimboFeed.transactions = formatTransactions(transactions, balance);

      return akimboFeed;
    };

    var formatTransactions = function(transactions, subBalance){
      var balance = subBalance;
      for(var t in transactions){
        // set index balance to current balance
        if(t === '0'){
          transactions[t].Balance = balance;
        } else {
          balance = balance - transactions[t - 1].Amount;
          transactions[t].Balance = balance;
        }
        transactions[t].FormattedDate = moment(transactions[t].Time).format('h:mma MMMM Do, YYYY');
      }
      return transactions;
    };

    var formatNotifications = function(notifications){
      for(var n in notifications){
        switch(notifications[n].Type){
          case '130':
            notifications[n].FormattedDate = moment(notifications[n].Time).format('MMMM Do, YYYY');
            notifications[n].FormattedTitle = notifications[n].Title;
            notifications[n].FormattedDescription = 'You\'ve scheduled a bank transfer of ' + $filter('akimboCurrency')(notifications[n].Amount, '$') + ' from your ' + notifications[n].Description + ' account. The transfer should post on ' + notifications[n].FormattedDate + '.';
            break;
          default:
            notifications[n].FormattedTitle = notifications[n].Title;
            notifications[n].FormattedDescription = notifications[n].Description;
            break;
        }
      }
      return notifications;
    };

    $scope.notificationClick = function(url){
      if(url){
        switch(url){
          case 'https://app.' + $scope.brand.programUrl + '/app/#/member/profile/changepin':
            $state.go('member.home.profile/changepin.step1');
            break;
          default:
            location.href = url;
            break;
        }
      }
    };

    if(!$stateParams.Username){
      $scope.getSubs();
    } else {
      $scope.getSubs(function(){
        $scope.getSubTransactions($stateParams.Username, $stateParams.Balance, $stateParams.FirstName);
      });
    }

  }]);
